import { forwardRef } from 'react';
import styles from './Toggle.module.css';

interface ToggleProps {
  checked: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
  'aria-label'?: string;
}

export const Toggle = forwardRef<HTMLButtonElement, ToggleProps>(
  ({ checked, onChange, disabled = false, className = '', 'aria-label': ariaLabel, ...props }, ref) => {
    const handleClick = () => {
      if (!disabled && onChange) {
        onChange(!checked);
      }
    };

    return (
      <button
        ref={ref}
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={ariaLabel}
        disabled={disabled}
        className={`${styles.toggle} ${checked ? styles.toggleActive : ''} ${className}`}
        onClick={handleClick}
        {...props}
      >
        <div className={styles.toggleHandle} />
      </button>
    );
  }
);

Toggle.displayName = 'Toggle';
